import axios from 'axios';
import {
  MEAL_PASS,
  MEAL_PASS_REPORT,
  MEAL_PASS_TIME_SLOTS,
  MEAL_PASS_DETAIL
} from '../../constant/API constant';

export const Get_Meal_Pass_Report = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${MEAL_PASS_REPORT}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const Get_Meal_Time_Slots = () => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${MEAL_PASS_TIME_SLOTS}`, {
    headers: { Authorization: jwt_token }
  });
};

export const Get_Meal_Pass_List = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${MEAL_PASS}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const Get_Meal_Pass_Detail = (mealId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${MEAL_PASS_DETAIL}`, {
    headers: { Authorization: jwt_token },
    params: { mealId }
  });
};

export const Create_Meal_Pass = (data) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${MEAL_PASS}`, data, {
    headers: { Authorization: jwt_token }
  });
};

export const Delete_Meal_Pass = (mealId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.delete(`${process.env.REACT_APP_API_URL}${MEAL_PASS}`, {
    headers: { Authorization: jwt_token },
    params: { mealId }
  });
};
